import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { LoadingButton } from './LoadingSkeleton';

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary",
  icon = null,
  isProcessing = false,
  processingText = "Processing..."
}) => {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      backdrop="static"
      keyboard={!isProcessing}
      className="confirmation-modal"
    >
      <Modal.Header closeButton={!isProcessing}>
        <Modal.Title>
          {icon && <i className={`${icon} me-2`}></i>}
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {typeof message === 'string' ? (
          <p className="mb-0">{message}</p>
        ) : (
          message
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide}
          disabled={isProcessing}
        >
          {cancelText}
        </Button>
        <LoadingButton
          variant={confirmVariant}
          onClick={handleConfirm}
          isLoading={isProcessing}
          loadingText={processingText}
        >
          {confirmText}
        </LoadingButton>
      </Modal.Footer>
    </Modal>
  );
};

// Specific confirmation modals
export const DeleteConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  itemName = "this item",
  itemType = "recipe",
  additionalWarning = null,
  isDeleting = false
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title={`Delete ${itemType}`}
      message={
        <>
          <p>Are you sure you want to delete <strong>"{itemName}"</strong>?</p>
          {additionalWarning && (
            <p className="text-warning mb-0">
              <i className="fas fa-exclamation-triangle me-2"></i>
              {additionalWarning}
            </p>
          )}
        </>
      }
      confirmText="Delete"
      confirmVariant="danger"
      icon="fas fa-trash"
      isProcessing={isDeleting}
      processingText="Deleting..."
    />
  );
};

export const TransitionConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  currentWeekCount,
  nextWeekCount,
  isTransitioning = false
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Activate Next Week's Plan"
      message={
        <div>
          <p>Are you sure you want to activate next week's plan?</p>
          <div className="alert alert-info">
            <strong>This will:</strong>
            <ul className="mb-0">
              <li>Delete all {currentWeekCount} recipes from your current week</li>
              <li>Remove recipe ingredients from your shopping list (manual items will be kept)</li>
              <li>Move all {nextWeekCount} recipes from next week to current week</li>
              <li>Add ingredients for the moved recipes to your shopping list</li>
            </ul>
          </div>
          <p className="text-danger mb-0">
            <i className="fas fa-exclamation-circle me-2"></i>
            <strong>This action cannot be undone.</strong>
          </p>
        </div>
      }
      confirmText="Activate Next Week"
      confirmVariant="success"
      icon="fas fa-calendar-check"
      isProcessing={isTransitioning}
      processingText="Transitioning..."
    />
  );
};

export default ConfirmationModal;